import {
  addFastagMaster,
  addFuelCardMaster,
  createBankAccountApi,
  createCashAccountApi,
  createFastagAccountApi,
  createFuelAccountApi,
  createOtherAccountApi,
  getAllVehicleNumber,
  getFastagMaster,
  getFuelCardMaster,
  handleKeyDown,
} from "_services";
import { getUserFirm } from "_services/accountsServices/firmServices";
import { getFastagCompanyDropdownData, getFuelCompanyDropdownData } from "_services/accountsServices/fuelStationServices";
import {
  CommonInput,
  CommonModal,
  Customdropdown,
  CustomSelect,
} from "components";
import images from "constants/images";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import AddEditVehicleModal from "modals/AddEditVehicleModal";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices";

const AddTransctionsModal = (props) => {
  let { onlyFuelCardShow = false, onlyFastTagShow = false, callListApis, callBackDataFromFastag = () => { }, isOpen, branchFirmId, hideAddNewOption = true } = props;
  const addTransactionsTabs = [
    { id: 1, title: "Cash", value: "cash", img: images.RP_WALLET.default },
    { id: 2, title: "Bank", value: "bank", img: images.BANK_ICON.default },
    {
      id: 3,
      title: "Fuel Card",
      value: "fuel_card",
      img: images.FUELCARD_ICON.default,
    },
    {
      id: 4,
      title: "Other",
      value: "other",
      img: images.OTHER_TRANS_ICON.default,
    },
    {
      id: 5,
      title: "Fastag",
      value: "fastag",
      img: images.FASTAG_ICON.default,
    },
  ];

  const initialFrom = {
    company_id: StorageServices.getCompanyId(),
    cash_name: "",
    cash_opting_bal: "",
    cash_credit_or_debit: 1,
    cash_prefix: "",
    show_cash_prefix: false,
    firm_id: {},

    holder_name: "",
    number: "",
    ifsc: "",
    bank: "",
    bank_opening_balance: "",
    bank_credit_or_debit: 1,
    bank_prefix: "",
    show_bank_prefix: false,
    vendor_account: false,

    other_name: "",
    other_opening_balance: "",
    other_credit_or_debit: 1,
    other_prefix: "",
    show_other_prefix: false,

    fuel_card_number: "",
    associate_vehicle_id: "",
    fuel_opening_balance: "",
    fuel_credit_or_debit: 1,
    fuel_card_master_id: "",

    fastag_id_number: "",
    fastag_associate_vehicle_id: "",
    fastag_opening_balance: "",
    fastag_credit_or_debit: 1,
    fastag_master_id: "",
  };

  const { masterData } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState(1);
  const [form, setForm] = useState(initialFrom);
  const [formError, setFormError] = useState("");
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
  const [isOpenFastagModal, setIsOpenFastagModal] = useState(false);
  const [masterFcList, setMasterFcList] = useState([]);
  const [MasterFastagList, setMasterFastagList] = useState([]);
  const [firmDataList, setFirmDataList] = useState([]);
  const [fastagCompanyList, setFastagCompanyList] = useState([]);
  const [fuelCardCompanyList, setFuelCardCompanyList] = useState([]);

  const [isOpenVehicleModal, setIsOpenVehicleModal] = useState(false);

  const changeActiveTab = async (event, value) => {
    event.preventDefault();
    setActiveTab(value);
  };

  // ✅ OPTIMIZED: Initial setup - sirf bank list
  // useEffect(() => {
  //   if (masterData) {
  //     const list = masterData?.bank_list?.map((i) => {
  //       return {
  //         label: i?.name,
  //         value: i?.code,
  //       };
  //     });
  //     if (list && list.length > 0) {
  //       setForm((prev) => ({ ...prev, bank: list[0].value }));
  //       setBankList(list);
  //     }
  //   }
  // }, [masterData]);

  // ✅ OPTIMIZED: onlyFuelCardShow/onlyFastTagShow ke basis par tab set karo
  useEffect(() => {
    if (onlyFuelCardShow) {
      setActiveTab(3);
    } else if (onlyFastTagShow) {
      setActiveTab(5);
    }
  }, [onlyFuelCardShow, onlyFastTagShow]);

  // ✅ OPTIMIZED: Active tab ke basis par required APIs call karo
  useEffect(() => {
    if (!masterData) return;

    // Tab 3: Fuel Card - Vehicle, Fuel Card Master, Fuel Company
    if (activeTab === 3) {
      if (vehicleList.length === 0) {
        getVehicleListData();
      }
      if (masterFcList.length === 0) {
        getMasterFc();
      }
      if (fuelCardCompanyList.length === 0) {
        getFuelCardCompanyStation();
      }
    }

    // Tab 5: Fastag - Vehicle, Fastag Master, Fastag Company
    if (activeTab === 5) {
      if (vehicleList.length === 0) {
        getVehicleListData();
      }
      if (MasterFastagList.length === 0) {
        getMasterFastTag();
      }
      if (fastagCompanyList.length === 0) {
        getFastagCompanyStation();
      }
    }
  }, [activeTab, masterData]);

  const getVehicleListData = async () => {
    try {
      const res = await getAllVehicleNumber({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        vehicle_ownership: [1, 3],
        offset: 1,
        limit: 2000
      });

      if (res?.responseCode === 200) {
        const list = res.data?.vehicle_list.map((i) => ({
          ...i,
          label: i.vehicle_no,
          value: i._id,
        }));
        setVehicleList(list);

        // Set default vehicle if needed
        if (list.length > 0) {
          if (activeTab === 3 && !form.associate_vehicle_id) {
            setForm((prev) => ({ ...prev, associate_vehicle_id: list[0].value }));
          }
          if (activeTab === 5 && !form.fastag_associate_vehicle_id) {
            setForm((prev) => ({ ...prev, fastag_associate_vehicle_id: list[0].value }));
          }
        }
      } else {
        toast.error(res?.responseMessage || "Failed to fetch vehicles");
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      toast.error("Error fetching vehicles.");
    }
  };

  const getMasterFc = async () => {
    try {
      const res = await getFuelCardMaster({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService?.getFirmId(),
        offset: 1,
        limit: 2000
      });
      if (res?.responseCode === 200) {
        setMasterFcList(
          res?.data?.fuelcard_master?.map((i) => ({
            ...i,
            label: i?.account_number,
            value: i?._id
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching fuel card master:", error);
    }
  };

  const getMasterFastTag = async () => {
    try {
      const res = await getFastagMaster({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService?.getFirmId(),
        offset: 1,
        limit: 2000
      });
      if (res?.responseCode === 200) {
        setMasterFastagList(
          res?.data?.fastag_master?.map((i) => ({
            ...i,
            label: i?.customer_id,
            value: i?._id
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching fastag master:", error);
    }
  };

  const getFastagCompanyStation = async () => {
    try {
      const res = await getFastagCompanyDropdownData({
        offset: 1,
        limit: 2000
      });

      if (res?.responseCode == 200) {
        setFastagCompanyList(
          res?.data?.fastag_company?.map((i) => ({
            ...i,
            label: i?.name,
            value: i?._id,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching fastag company:", error);
    }
  };

  const getFuelCardCompanyStation = async () => {
    try {
      const res = await getFuelCompanyDropdownData({
        offset: 1,
        limit: 2000
      });

      if (res?.responseCode == 200) {
        setFuelCardCompanyList(
          res?.data?.fuelcard_company?.map((i) => ({
            ...i,
            label: i?.name,
            value: i?._id,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching fuel company:", error);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = { ...form, [name]: value };

    if (name === "show_bank_prefix" && value == false) {
      stateObj.bank_prefix = '';
    }

    if (name === "ifsc" && value.length === 11) {
     
      try {
        const bankDetails = await handleSearch(value);

        if (bankDetails && bankDetails.BRANCH) {
          stateObj.branch_name = bankDetails.BRANCH;
          stateObj.branch_code = bankDetails.BANKCODE;
          stateObj.city_name = bankDetails.CITY;
          stateObj.state_name = bankDetails.STATE;
          stateObj.bank = bankDetails.BANK;
          // stateObj.holder_name = bankDetails.BANK;

        } else {

          stateObj.branch_name = "";
          setFormError(prev => ({
            ...prev,
            ifsc: "invalid IFSC code",
          }));
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        stateObj.branch_name = "";
      }
    }

    setForm(stateObj);

    if (!!formError) {
      const validationSchemas = {
        1: errorSchema.cashSchema,
        2: errorSchema.bankSchema,
        3: errorSchema.fuelSchema,
        4: errorSchema.otherSchema,
        5: errorSchema.fastagSchema,
      };
      const validationResult = await utils.checkFormError(
        stateObj,
        validationSchemas[activeTab]
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleOnSubmit = async () => {
    const validationSchemas = {
      1: errorSchema.cashSchema,
      2: errorSchema.bankSchema,
      3: errorSchema.fuelSchema,
      4: errorSchema.otherSchema,
      5: errorSchema.fastagSchema,
    };

    const validationResult = await utils.checkFormError(
      { ...form },
      validationSchemas[activeTab]
    );

    const payloads = {
      1: {
        company_id: form?.company_id,
        name: form?.cash_name,
        opening_balance: form?.cash_opting_bal,
        credit_or_debit: form?.cash_credit_or_debit,
        prefix: form?.cash_prefix,
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
      },
      2: {
        company_id: form?.company_id,
        name: form?.holder_name,
        number: form?.number,
        ifsc: form?.ifsc,
        bank: form?.bank,
        opening_balance: form?.bank_opening_balance,
        credit_or_debit: form?.bank_credit_or_debit,
        prefix: form?.bank_prefix,
        vendor_account: form?.vendor_account,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',

      },
      3: {
        company_id: form?.company_id,
        account_number: form?.fuel_card_number,
        associate_vehicle_id: form?.associate_vehicle_id,
        opening_balance: form?.fuel_opening_balance,
        credit_or_debit: form?.fuel_credit_or_debit,
        fuelcard_master_id: form?.fuel_card_master_id,
      },
      4: {
        company_id: form?.company_id,
        name: form?.other_name,
        opening_balance: form?.other_opening_balance,
        credit_or_debit: form?.other_credit_or_debit,
        prefix: form?.other_prefix,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',
      },
      5: {
        company_id: form?.company_id,
        account_number: form?.fastag_id_number,
        associate_vehicle_id: form?.fastag_associate_vehicle_id,
        opening_balance: form?.fastag_opening_balance,
        credit_or_debit: form?.fastag_credit_or_debit,
        fastag_master_id: form?.fastag_master_id,
      },
    };

    const apiCalls = {
      1: createCashAccountApi,
      2: createBankAccountApi,
      3: createFuelAccountApi,
      4: createOtherAccountApi,
      5: createFastagAccountApi,
    };

    if (validationResult == true) {
      setLoading(true);
      try {
        const payload = payloads[activeTab];
        const apiCall = apiCalls[activeTab];

        if (!payload || !apiCall) {
          toast?.error("Invalid tab or missing payload");
          return;
        }

        const res = await apiCall(payload);
        if (res?.responseCode === 200) {
          callBackDataFromFastag(res?.data?.fastag_account);
          setLoading(false);
          props?.closeModal();
          if (!onlyFuelCardShow && !onlyFastTagShow) {
            props?.getAccountListHandler();
          }
          if (onlyFuelCardShow || onlyFastTagShow) {
            callListApis();
          }
          toast?.success(res?.responseMessage ? res?.responseMessage : "Account add successfully");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
      }
    } else {
      setLoading(false);
      setFormError(validationResult);
    }
  };

  const addFuelCardHandle = (data) => {
    setIsOpenFuelModal(true);
  };

  const addFastagHandle = (data) => {
    setIsOpenFastagModal(true);
  };

  const callBackApi = (data) => {
    if (data?.fastag_master) {
      getMasterFastTag();
      handleOnChange("fastag_master_id", data?.fastag_master?._id);
    }

    if (data?.fuelcard_master) {
      getMasterFc();
      handleOnChange("fuel_card_master_id", data?.fuelcard_master?._id);
    }
  };


  const handleSearch = async (ifscCode) => {
    // Fetch bank details from Razorpay IFSC API

    const validateIFSC = (code) => {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      return ifscRegex.test(code.toUpperCase());
    };
    const valid = validateIFSC(ifscCode);


    if (valid) {
   
      try {
        const res = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
        if (!res.ok) {
          return res
        }
        const data = await res.json();
        return data
      } catch (err) {
        toast.error(err.message);
      }
    }
  }

  const getDataFirmList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
      }
      const res = await getUserFirm(object);
      if (res?.responseCode == 200) {
        let apiData = res?.data?.firm_list?.map((el) => {

          return {
            ...el,
            label: el?.firm_id?.firm,
            value: el?.firm_id?._id,
          }
        })
        setFirmDataList(apiData);
        // if (!isOpen?._id) {
        if (apiData?.length === 1) {
          setForm((s) => ({
            ...s,
            firm_id: apiData[0]
          }))
        } else {
          setForm((s) => ({
            ...s,
            firm_id: {}
          }))
        }
        // }
      }
    } catch (error) {
    }
  }

  useEffect(() => {
    getDataFirmList();
  }, [])

  // useEffect(() => {
  //   if (firmDataList?.length > 0) {
  //     let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
  //     setForm((s) => ({
  //       ...s,
  //       firm_id: findObject?.value ? findObject : {}
  //     }))
  //   }
  // }, [StorageService.getFirmId(), firmDataList, isOpen])

  useEffect(() => {

    if (firmDataList?.length > 0 && !isOpen?._id) {
      const storageFirmId = StorageService.getFirmId();

      let findObject = firmDataList.find((el) => el?.value === storageFirmId);

      const branchFirm = branchFirmId?._id;
      let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

      setForm((s) => ({
        ...s,
        ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
      }));
    }
  }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);

  const propsTransAccount = {
    ...props,
    onSubmit: handleOnSubmit,
    isLoadding: loading,
    disabled: loading,
    show: isOpenFuelModal || isOpenFastagModal ? "" : "show",
    firm: form?.firm_id
  };

  let openZoneModal = {
    isOpen: isOpenFuelModal,
    closeModal: (e) => setIsOpenFuelModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Add Fuel Card Master',
    submitTitle: 'Add FC Master',
    footerPart: true,
    label: "Fuel Card Master *",
    placeholder: "Enter Fuel Card Master ",
    isLabelData: 'Fuel Card Company',
    ApiPoint: addFuelCardMaster,
    callBackApi: callBackApi,
    titleName: "fuel_card",
    fuelCardCompanyList: fuelCardCompanyList,
  };

  let openFastagModal = {
    isOpen: isOpenFastagModal,
    closeModal: (e) => setIsOpenFastagModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Add Fastag Master',
    submitTitle: 'Add Fastag Master',
    footerPart: true,
    label: "Fastag Master *",
    placeholder: "Enter Fastag Master ",
    isLabelData: 'Fastag Company',
    ApiPoint: addFastagMaster,
    callBackApi: callBackApi,
    titleName: "fastag",
    fastagCompanyList: fastagCompanyList,
  };

  // Refresh vehicle list after adding new vehicle
  const handleVehicleAdded = () => {
    getVehicleListData();
  };
  return (
    <>
      <CommonModal {...propsTransAccount}>
        <div className="addLr_body">
          {(!onlyFuelCardShow && !onlyFastTagShow) ? (
            <div className="addPr_flBx _addTrns_flx">
              <ul
                className="nav nav-tabs cstNew_tabs _truckSelection"
                id="addParty"
                role="tablist"
              >
                {addTransactionsTabs?.length > 0 ? (
                  addTransactionsTabs?.map((item, indx) => (
                    <li className="nav-item" role="presentation" key={indx}>
                      <button
                        id={item?.id}
                        className={
                          "nav-link " + (item?.id === activeTab ? "active" : "")
                        }
                        type="button"
                        aria-selected={item?.id === activeTab}
                        onClick={(e, val) => changeActiveTab(e, item?.id)}
                      >
                        <img src={item.img} className="" />
                        {item?.title}
                      </button>
                    </li>
                  ))
                ) : (
                  <p className="p-2 mt-3"> Loading... </p>
                )}
              </ul>
            </div>
          ) : <></>}

          {activeTab === 1 && (
            <>
              <div className="_allDflx mt-4">
                {firmDataList?.length > 1 && <div className='singleDiv'>
                  <CustomSelect
                    options={firmDataList}
                    label="Select Firm"
                    placeholder="Select Firm"
                    name="firm_id"
                    value={form?.firm_id}
                    error={formError["firm_id.label"]}
                    onSelect={(data) => handleOnChange('firm_id', data)}
                    disabled={hideAddNewOption ? false : (form?.firm_id?.value ? true : false)}

                  />
                </div>}
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Cash Account Name"
                    label="Cash Account Name"
                    name="cash_name"
                    focus={!!formError?.cash_name}
                    error={formError.cash_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.cash_name}
                    maxLength={30}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="cash_opting_bal"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.cash_opting_bal}
                    error={formError.cash_opting_bal}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.cash_opting_bal}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="cash_credit_or_debit"
                        checked={i.value == form.cash_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                {!form?.show_cash_prefix && (
                  <div className="d-flex justify-content-end">
                    <button
                      className="_addMo_deBtn"
                      onClick={() => handleOnChange("show_cash_prefix", true)}
                    >
                      Add More Detail
                    </button>
                  </div>
                )}

                {form?.show_cash_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="cash_prefix"
                      focus={!!formError?.cash_prefix}
                      error={formError.cash_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.cash_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === 2 && (
            <>
              <div className="_allDflx mt-4">
                {firmDataList?.length > 1 && <div className='singleDiv'>
                  <CustomSelect
                    options={firmDataList}
                    label="Select Firm"
                    placeholder="Select Firm"
                    name="firm_id"
                    value={form?.firm_id}
                    error={formError["firm_id.label"]}
                    onSelect={(data) => handleOnChange('firm_id', data)}
                    disabled={hideAddNewOption ? false : (form?.firm_id?.value ? true : false)}

                  />
                </div>}
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Bank Account Name"
                    label="Bank Account Name"
                    name="holder_name"
                    focus={!!formError?.holder_name}
                    error={formError.holder_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.holder_name}
                    maxLength={30}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.123456789012345"
                    label="Account Number"
                    name="number"
                    focus={!!formError?.number}
                    error={formError.number}
                    onChange={({ target: { name, value } }) => {
                      if (/^\d*$/.test(value)) {
                        handleOnChange(name, value);
                      }
                    }}
                    maxLength={20}
                    value={form?.number}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.SBIN0000000"
                    label="IFSC Code"
                    name="ifsc"
                    focus={!!formError?.ifsc}
                    error={formError.ifsc}
                    // onChange={({ target: { name, value } }) =>
                    //   handleOnChange(name, value)
                    // }
                    onChange={({ target: { name, value } }) => {

                      const upperLatter = value.toUpperCase();

                      handleOnChange(name, upperLatter)
                    }

                    }
                    value={form?.ifsc}
                    maxLength={11}
                  />
                </div>

                {/* <div>
                  <CustomSelect
                    options={bankList}
                    label="Bank Name"
                    placeholder="Bank Name"
                    name="bank"
                    focus={!!formError?.bank}
                    error={formError.bank}
                    onSelect={(data) => handleOnChange("bank", data?.value)}
                    value={bankList?.find((i) => i?.value == form?.bank)}
                  />
                </div> */}

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="bank_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.bank_opening_balance}
                    error={formError.bank_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.bank_opening_balance}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="bank_credit_or_debit"
                        checked={i.value == form.bank_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>




                <div className="d-flex gap-4" style={{ fontWeight: 500 }}>
                  Supplier / Vendor Account
                </div>
                <div className="d-flex gap-5">
                  {[
                    { label: "Required", value: true },
                    { label: "Not Required", value: false },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i.label}>
                      <input
                        className="form-check-input"
                        id={i.label}
                        type="radio"
                        name="vendor_account"
                        checked={form.vendor_account === i.value}
                        value={i.value}
                        onChange={({ target }) =>
                          handleOnChange(target.name, target.value === "true")
                        }
                      />
                      <label htmlFor={i.label} className="form-check-label">
                        {i.label}
                      </label>
                    </div>
                  ))}
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="_addMo_deBtn"
                    onClick={() => handleOnChange("show_bank_prefix", !form?.show_bank_prefix)}
                  >
                    {form?.show_bank_prefix ? "Remove More Details" : "Add More Detail"}
                  </button>
                </div>
                {form?.show_bank_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="bank_prefix"
                      focus={!!formError?.bank_prefix}
                      error={formError.bank_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.bank_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === 3 && (
            <>
              <div className={onlyFuelCardShow ? "_allDflx" : "_allDflx mt-4"}>

                {firmDataList?.length > 1 && <div className='singleDiv'>
                  <CustomSelect
                    options={firmDataList}
                    label="Select Firm"
                    placeholder="Select Firm"
                    name="firm_id"
                    value={form?.firm_id}
                    error={formError["firm_id.label"]}
                    onSelect={(data) => handleOnChange('firm_id', data)}
                    disabled={hideAddNewOption ? false : (form?.firm_id?.value ? true : false)}

                  />
                </div>}
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Fuel Card Number"
                    label="Fuel Card Number"
                    name="fuel_card_number"
                    focus={!!formError?.fuel_card_number}
                    error={formError.fuel_card_number}
                    onChange={(e) => utils.handleNoSpecialCharInputChange(e, handleOnChange)}
                    value={form?.fuel_card_number}
                    maxLength={20}
                  />
                </div>

                <div>
                  <CustomSelect
                    options={vehicleList}
                    label="Associate Vehicle"
                    placeholder="Associate Vehicle"
                    name="associate_vehicle_id"
                    isAddButton={true}
                    addButtonAction={() => {
           
                     
                      if (form?.firm_id?.value) {
                        setIsOpenVehicleModal(true);
                      } else {
                        toast.error("Select Firm First");
                      }
                    }}
                    focus={!!formError?.associate_vehicle_id}
                    error={formError.associate_vehicle_id}
                    onSelect={(data) =>
                      handleOnChange("associate_vehicle_id", data?.value)
                    }
                    value={vehicleList?.find(
                      (i) => i?.value == form?.associate_vehicle_id
                    )}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="fuel_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.fuel_opening_balance}
                    error={formError.fuel_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.fuel_opening_balance}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="fuel_credit_or_debit"
                        checked={i.value == form.fuel_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                <div>
                  <CustomSelect
                    options={masterFcList}
                    label="Fuel Card Master"
                    placeholder="Fuel Card Master"
                    name="fuel_card_master_id"
                    focus={!!formError?.fuel_card_master_id}
                    error={formError.fuel_card_master_id}
                    onSelect={(data) =>
                      handleOnChange("fuel_card_master_id", data?.value)
                    }
                    isAddButton={true}
                    addButtonAction={addFuelCardHandle}
                    value={form?.fuel_card_master_id ? masterFcList?.find((i) => i?.value == form?.fuel_card_master_id) : { label: "", value: "" }}
                  />
                </div>
              </div>
            </>
          )}

          {activeTab === 4 && (
            <>
              <div className="_allDflx mt-4">
                {firmDataList?.length > 1 && <div className='singleDiv'>
                  <CustomSelect
                    options={firmDataList}
                    label="Select Firm"
                    placeholder="Select Firm"
                    name="firm_id"
                    value={form?.firm_id}
                    error={formError["firm_id.label"]}
                    onSelect={(data) => handleOnChange('firm_id', data)}
                  />
                </div>}
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Account Name"
                    label="Account Name"
                    name="other_name"
                    focus={!!formError?.other_name}
                    error={formError.other_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.other_name}
                    maxLength={30}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="other_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.other_opening_balance}
                    error={formError.other_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.other_opening_balance}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="other_credit_or_debit"
                        checked={i.value == form.other_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                {!form?.show_other_prefix && (
                  <div className="d-flex justify-content-end">
                    <button
                      className="_addMo_deBtn"
                      onClick={() => handleOnChange("show_other_prefix", true)}
                    >
                      Add More Detail
                    </button>
                  </div>
                )}

                {form?.show_other_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="other_prefix"
                      focus={!!formError?.other_prefix}
                      error={formError.other_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.other_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}

          {activeTab === 5 && (
            <>
              <div className={onlyFastTagShow ? "_allDflx" : "_allDflx mt-4"}>
                <div>
                  <CommonInput
                    type="text"
                    placeholder="Fastag ID Number"
                    label="Fastag ID Number"
                    name="fastag_id_number"
                    focus={!!formError?.fastag_id_number}
                    error={formError.fastag_id_number}
                    onChange={(e) => utils.handleNoSpecialCharInputChange(e, handleOnChange)}
                    value={form?.fastag_id_number}
                    maxLength={14}
                  />
                </div>

                <div>
                  <CustomSelect
                    options={vehicleList}
                    label="Associate Vehicle"
                    placeholder="Associate Vehicle"
                    name="fastag_associate_vehicle_id"
                    focus={!!formError?.fastag_associate_vehicle_id}
                    error={formError.fastag_associate_vehicle_id}
                    isAddButton={true}
                    addButtonAction={(e) => setIsOpenVehicleModal(true)}
                    onSelect={(data) =>
                      handleOnChange("fastag_associate_vehicle_id", data?.value)
                    }
                    value={vehicleList?.find(
                      (i) => i?.value == form?.fastag_associate_vehicle_id
                    )}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance"
                    label="Opening Balance (₹)"
                    name="fastag_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.fastag_opening_balance}
                    error={formError.fastag_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.fastag_opening_balance}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="fastag_credit_or_debit"
                        checked={i.value == form.fastag_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                <div>
                  <CustomSelect
                    options={MasterFastagList}
                    label="Fastag Master Account"
                    placeholder="Fastag  Master Account"
                    name="fastag_master_id"
                    focus={!!formError?.fastag_master_id}
                    error={formError.fastag_master_id}
                    onSelect={(data) =>
                      handleOnChange("fastag_master_id", data?.value)
                    }
                    isAddButton={true}
                    addButtonAction={addFastagHandle}
                    value={form?.fastag_master_id ? MasterFastagList?.find((i) => i?.value == form?.fastag_master_id) : { label: "", value: "" }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </CommonModal>

      {isOpenFuelModal && <AddEditModal {...openZoneModal} />}
      {isOpenFastagModal && <AddEditModal {...openFastagModal} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpenVehicleModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: isOpenVehicleModal ? 'visible' : 'hidden', zIndex: isOpenVehicleModal ? '9999' : '' }}
      >
        {isOpenVehicleModal && (
          <AddEditVehicleModal
            isOpen={isOpenVehicleModal}
            onClose={() => setIsOpenVehicleModal(false)}
            isChildDriverSuplier={true}
            showOnlyOwn_Leased={false}
            isListFunctionCall={handleVehicleAdded}
            hideAddNewOption={false}
            branchFirmId={form?.firm_id?.firm_id || StorageService.getFirmId()}
          />
        )}
      </div>
      <div style={{ zIndex: isOpenVehicleModal ? '9998' : '' }} className={isOpenVehicleModal ? 'offBack_drop' : ''}></div>
    </>
  );
};

export default AddTransctionsModal;